<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M12.2488 4.75047C12.0961 4.90625 12.0105 5.11568 12.0105 5.33381C12.0105 5.55193 12.0961 5.76136 12.2488 5.91714L13.5821 7.25047C13.7379 7.40316 13.9473 7.48869 14.1654 7.48869C14.3836 7.48869 14.593 7.40316 14.7488 7.25047L17.3371 4.66297C17.6038 4.39464 18.0563 4.47964 18.1563 4.84464C18.408 5.76037 18.3938 6.72886 18.1152 7.6368C17.8367 8.54474 17.3053 9.35456 16.5832 9.9715C15.8612 10.5885 14.9784 10.987 14.0381 11.1205C13.0979 11.2541 12.139 11.117 11.2738 10.7255L4.68209 17.3171C4.35057 17.6485 3.90098 17.8347 3.43222 17.8346C2.96345 17.8345 2.51392 17.6482 2.18251 17.3167C1.8511 16.9852 1.66496 16.5356 1.66504 16.0668C1.66512 15.5981 1.85141 15.1485 2.18293 14.8171L8.77459 8.22547C8.38305 7.36023 8.24602 6.40137 8.37954 5.4611C8.51306 4.52082 8.91161 3.63801 9.52856 2.91598C10.1455 2.19395 10.9553 1.66256 11.8633 1.38399C12.7712 1.10542 13.7397 1.09119 14.6554 1.34297C15.0204 1.44297 15.1054 1.89464 14.8379 2.16297L12.2488 4.75047Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconWrench',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
